import React, { Fragment } from 'react';
import { withStateHandlers, nest, compose } from 'recompose';
import Modal from 'components/general/Modal/Modal';
import withRenderPropsFactory from 'components/hoc/withRenderPropsFactory';

// Place a <Modal /> next to the target. Will render in a portal.
const ModalWrapper: React.SFC<WrapperProps> = ({
  promptOpen,
  closePrompt,
  renderPrompt,
  children,
}) => (
  <Fragment>
    <Modal isOpen={promptOpen} onClose={closePrompt}>
      {renderPrompt && renderPrompt()}
    </Modal>
    {children}
  </Fragment>
);

const withPrompt: withPromptType = () => Component => compose(
  withStateHandlers(
    (props: InputProps) => ({
      promptOpen: props.promptOpen || false,
    }),
    {
      openPrompt: () => () => ({
        promptOpen: true,
      }),
      closePrompt: () => () => ({
        promptOpen: false,
      }),
    },
  ),
  withRenderPropsFactory({
    props: ['renderPrompt'],
  }),
)(nest(ModalWrapper, Component));

interface InputProps {
  renderPrompt?();
  promptOpen?: boolean;
  [x: string]: any;
}

interface OutputProps {
  openPrompt();
  renderPrompt?();
  [x: string]: any;
}

interface WrapperProps extends InputProps {
  closePrompt();
}

interface withPromptType {
  (options?: object): subType;
}

interface subType {
  (Component: React.SFC<OutputProps>): React.SFC<InputProps>;
}

export default withPrompt;
